export enum NotificationType {
    PUSH = 'push',
    EMAIL = 'email',
    POPUP = 'popup',
}

export enum NotificationTopic {
    ORDER = 'order',
    NEWS = 'news',
    PRODUCT_PROMOTION = 'productPromotion',
    PROMOTION = 'promotion',
    MESSAGE = 'message',
    REMINDER = 'reminder',
    UNKNOWN = 'unknown'
}

export enum INFORMATION_TYPE {
    NEWS = 'news',
    PRODUCT_PRESENTATION = 'productPresentation',
    PROMOTION = 'promotion'
}

export enum PROMOTION_TYPE {
    BONUS_SAME = "BONUS_SAME",                       // Zugabe-Aktion: sortenrein
    BONUS_FLEXIBLE = "BONUS_FLEXIBLE",               // Zugabe-Aktion: frei wählbar
    PROMO_BUNDLE = "PROMO_BUNDLE",                   // Aktionspaket
    CASHBACK = "CASHBACK",                           // Rückvergütung
    SWEEPSTAKES = "SWEEPSTAKES"                      // Gewinnspiel
}

export type InformationKeys = keyof typeof INFORMATION_TYPE

export enum STAKEHOLDER_KIND {
    SUPPLIER = 'supplier',
    ADVERTISER = 'advertiser',
    MANUFACTURER = 'manufacturer',
    CREW = 'crew',
    OCTOPUS = 'octopus',
}

export enum AUDIENCE_TYPE {
    ALL = 'all',
    CUSTOMER = 'customer'
}

export enum TRACKING_EVENT {
    VIEW = 'view',
    CLICK = 'click'
}

export enum ReturnStatus {
    UNKNOWN = 'Unknown',
    OK = 'Ok',
    BAD_REQUEST = 'BadRequest',
    NOT_FOUND = 'NotFound',
    UNAUTHORIZED = 'Unauthorized',
    FORBIDDEN = 'Forbidden',
    NOT_IMPLEMENTED = 'NotImplemented',
    INVALID_LOGIN = 'InvalidLogin',
    INVALID_SESSION = 'InvalidSession',
    INVALID_PASSWORD = 'InvalidPassword',
    USER_NOT_FOUND = 'UserNotFound',
    USER_ALREADY_EXISTS = 'UserAlreadyExists',
    USER_EMAIL_ALREADY_EXISTS = 'UserEmailAlreadyExists',
    EMAIL_INVALID = 'EmailInvalid',
    LOCATION_NOT_FOUND = 'LocationNotFound',
    CART_ITEM_NOT_FOUND = 'CartItemNotFound',
    ITEM_ALREADY_IN_CART = 'ItemAlreadyInCart',
    LIST_ALREADY_IN_CART = 'ListAlreadyInCart',
    LIST_EMPTY = 'ListEmpty',
    SUPPLIER_NOT_FOUND = 'SupplierNotFound',
    SUPPLIER_ITEM_NOT_FOUND = 'SupplierItemNotFound',
    ORDER_NOT_FOUND = 'OrderNotFound',
    LIST_NOT_FOUND = 'ListNotFound',
    LIST_ITEM_NOT_FOUND = 'ListItemNotFound',
    ITEM_ALREADY_IN_LIST = 'ItemAlreadyInList',
    ITEM_NOT_FROM_LIST_SUPPLIER = 'ItemNotFromListSupplier',
    LIST_CANT_BE_DELETED = 'ListCantBeDeleted',
    NOTIFICATION_NOT_FOUND = 'NotificationNotFound',
    TAG_NOT_FOUND = 'TagNotFound',
    TAG_ALREADY_EXISTS = 'TagAlreadyExists',
    USER_NOT_IN_TEAM = 'UserNotInTeam',
    OWNER_CANT_BE_EDITED = 'OwnerCantBeEdited',
    TOKEN_INVALID = 'TokenInvalid',
    TOKEN_INVALID_ALREADY_USED = 'TokenInvalidAlreadyUsed',
    REMINDER_NOT_FOUND = 'ReminderNotFound',
    PROMO_CODE_INVALID = 'PromoCodeInvalid',
    PROMO_CODE_INVALID_ALREADY_EXISTS = 'PromoCodeInvalidAlreadyExists',
    QUICK_START_CODE_INVALID = 'QuickStartCodeInvalid',
    SUPPLIER_ALREADY_EXISTS = 'SupplierAlreadyExists',
    SUPPLIER_CUSTOMER_INVALID = 'SupplierCustomerInvalid',
    SUPPLIER_BLOCKED = 'SupplierBlocked',
    LOCATION_ALREADY_EXISTS = 'LocationAlreadyExists',
    JAVA_API_INTERNAL_SERVER_ERROR = 'JavaApiInternalServerError',
    NEWS_NOT_FOUND = 'NewsNotFound',
    ORDER_MESSAGE_TOO_LONG = 'OrderMessageTooLong',
    PROMOTION_EXPIRED = 'PromotionExpired'
}
